import { ActivatedRoute } from '@angular/router';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WalletService } from '../../services/wallet.service';

import { MessageService, RouteStateService } from '@client-monorepo/common/utilities';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { WALLETS_ROUTE } from '../../../../data-access/constants/app-routes';
import { WalletPayableInfoComponent } from '../../components/wallet-payable-info/wallet-payable-info.component';
import { WalletAmountFormComponent } from '../../components/wallet-amount-form/wallet-amount-form.component';
import { WalletTransactionInfoComponent } from '../../components/wallet-transaction-info/wallet-transaction-info.component';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { IProcessData } from '../../models/wallet-process.interface';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { IWalletProcess } from '../../models/wallet-cashin-model.interface';
import { WALLET_WITHDROW_PROCESS_API } from '../../../../data-access/constants/api';

@Component({
  selector: 'wealth-applet-wallet-cash-out',
  standalone: true,
  imports: [PipesModule, NgxButtonComponent, NgxAppBarComponent, MatTooltipModule, WalletPayableInfoComponent, WalletAmountFormComponent],
  templateUrl: './wallet-cashout.component.html',
  styleUrl: './wallet-cashout.component.scss',
})
export class WalletCashoutComponent implements OnInit {
  btnLoading = signal<boolean>(false);
  isValid = signal<boolean>(false);
  state = signal<IProcessData | undefined>(undefined);
  walletId = signal<string | undefined>(undefined);
  amount = signal<string | undefined>(undefined);
  iban = signal<string | undefined>(undefined);

  private walletService = inject(WalletService);
  private routeState = inject(RouteStateService);
  private activatedRoute = inject(ActivatedRoute);
  private messageService = inject(MessageService);
  private bottomSheet = inject(NgxBottomSheetService);
  private navigationService = inject(WealthNavigationService);

  ngOnInit(): void {
    this.state.set(this.routeState.getAll());
    this.walletId.set(this.activatedRoute.snapshot.params['id']);
    if (!this.state()?.walletName) {
      this.navigationService.navigate([WALLETS_ROUTE, this.walletId()]);
    } else {
      if (this.state().bottomSheetName === 'page_wallet_cach_out_landing_confirmed') {
        this.openBottomSheet(this.state());
      }
      if (this.state().amount) {
        this.isValid.set(true);
      }
    }
  }

  private openBottomSheet(data: IProcessData) {
    const bottomSheetData = {
      type: 'cashOut',
      walletId: this.walletId(),
      walletName: data.walletName,
      walletTitle: data.walletTitle,
      iban: data.shebaNumber,
      amount: data.amount,
    };
    this.bottomSheet.openBottomSheet(
      WalletTransactionInfoComponent,
      {
        data: bottomSheetData,
      },
      {
        noPadding: true,
      },
    );

    this.bottomSheet.onClose.subscribe(() => {
      this.amount.set(' ');
      this.state().amount = ' ';
    });
  }

  onBackHandler() {
    this.navigationService.navigate([WALLETS_ROUTE, this.walletId()], {
      state: {
        ...this.state(),
      },
    });
  }

  cashout(segment?: string) {
    if (segment === 'all') {
      this.amount.set(`${this.state().walletWithdrawableBalance}`);
      this.state().amount = this.amount();
    }
    this.btnLoading.set(true);
    const processData: IWalletProcess = {
      walletTitle: this.state().walletTitle,
      walletUncollectibleBalance: this.state().walletUncollectibleBalance,
      walletWithdrawableBalance: this.state().walletWithdrawableBalance,
      minAmount: this.state().minAmount,
      amount: this.amount(),
      walletId: this.walletId(),
      walletName: this.state().walletName,
    };
    this.walletService.walletProcess(WALLET_WITHDROW_PROCESS_API, processData).subscribe((res) => {
      if (res.success) {
        if (res && res.result && res.result.action === 'error') {
          this.messageService.showErrorMessage(res.result.data.message);
        } else if (res.result.action === 'bottomSheet') {
          this.openBottomSheet(res.result.data);
        }
      }
      this.btnLoading.set(false);
    });
  }

  amountChange(data: { value: string; valid: boolean }) {
    this.isValid.set(data.valid);
    this.amount.set(data.value);
    this.state().amount = data.value;
  }
}
